<template>
  <b-navbar toggleable="md" class="sidebar">
    <b-navbar-toggle target="sidebar-collapse"></b-navbar-toggle>
    <b-collapse id="sidebar-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item>
          <div class="user">
            <div class="photo">
              <UserPhoto :user="currentUser" />
            </div>
            <div class="info" v-if="currentUser">
              <div>
                {{currentUser.name | firstname}}
                <br>
                <small v-if="userRole">({{ userRole }})</small>
              </div>
              <div id="info">
                <router-link class="btn btn-primary btn-sm" :to="'/editar-usuario/'+ currentUser._id">
                  <span class="sidebar-normal"> Editar</span>
                </router-link>
                <router-link  class="btn btn-secondary btn-sm" to="/logout">
                  <span class="sidebar-normal"> Sair </span>
                </router-link>
              </div>
            </div>
          </div>
        </b-nav-item>
        <div class="clearfix" />
        <hr>
        <b-nav-item to="/painel">
          Início
        </b-nav-item>
        <b-nav-item to="/pedidos">
          <span v-if="isA('client')">Meus pedidos</span>
          <span v-else>Pedidos</span>
        </b-nav-item>
        <b-nav-item v-if="isManager" to="/demandas">
          Demandas
        </b-nav-item>
        <b-nav-item v-if="isSupplier" to="/boletos">
          Boletos
        </b-nav-item>
        <b-nav-item v-if="isSupplier" to="/ofertas">
          Ofertas
        </b-nav-item>
        <b-nav-item v-if="isSupplier" to="/ofertas-coletivas">
          Ofertas coletivas
        </b-nav-item>
        <b-nav-item v-if="isSupplier" to="/produtos">
          Produtos
        </b-nav-item>
        <b-nav-item v-if="isSeller" to="/clientes">
          Clientes
        </b-nav-item>
        <b-nav-item v-if="isManager" to="/fornecedores">
          Fornecedores
        </b-nav-item>
        <b-nav-item to="/redes" v-if="isLink">
          Redes
        </b-nav-item>
        <b-nav-item v-if="isSupplier" to="/usuarios">
          Usuários
        </b-nav-item>
        <b-nav-item v-if="isSupplier" to="/relatorios">
          Relatórios
        </b-nav-item>
        <b-nav-item-dropdown text="Conteúdo" right>
          <b-dropdown-item to="/editar-conteudo/quem-somos">Quem Somos</b-dropdown-item>
          <b-dropdown-item to="/editar-conteudo/como-funciona">Como funciona</b-dropdown-item>
          <b-dropdown-item to="/editar-conteudo/o-que-move">O que nos move</b-dropdown-item>
          <b-dropdown-item to="/editar-banner">Banner</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item to="/loja">
          Loja
        </b-nav-item>
      </b-navbar-nav>
      <br>
    </b-collapse>
  </b-navbar>
</template>

<script>
import UserPhoto from '@/components/UserPhoto'
import tipos_de_usuario from '@/data/tipos-de-usuario.json'
export default {
  components: {
    UserPhoto
  },
  computed: {
    showMenu() {
      return this.$store.state.showMenu
    },
    userRole() {
      var role = tipos_de_usuario.find(tipo_de_usuario => this.currentUser.roles[0] === tipo_de_usuario.value)
      if (role) {
        return role.text
      }
      return ''
    }
  },
  data() {
    return {
      show_content_menu: false
    }
  },
  methods: {
    toggleContentMenu() {
      this.show_content_menu = !this.show_content_menu
    },
    toggleMenu() {
      this.$store.dispatch('toggleMenu')
    }
  }
};
</script>
<style lang="sass" scoped>
  .navbar
    display: block
    padding: 0
    .navbar-toggler
      float: right
    .navbar-collapse
      padding-top: -15px
      align-items: unset
      .navbar-nav
        display: block
      .nav-item
        display: block
        a:not(.btn)
          color: #215F60
        &.dropdown
          border: 0
          padding: 0
          &:active
            border: 0
            padding: 0
  .user
    .photo
      float: left
      margin-bottom: 15px
      margin-right: 15px
    .info
      float: left
      cursor: pointer
      .btn
        margin-right: 5px
        color: #fff
  .menu
    margin-top: 25px
    padding: 0
    li
      display: block
      a
        padding: 0
        font-weight: 400
</style>
